import axios from "axios";

let language = document.documentElement.lang.toUpperCase();

export default {
    get() {
        const API = `/api/payment/PaypalCredentials`;

        return new Promise((resolve, reject) => {
            axios.post(API).then(res => {
                    resolve(res.data.clientID);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};